module.exports = "<div class=\"cardup\">\r\n    <h3>{{title}} BLSA</h3>\r\n</div>\r\n<div [id]=\"barChartWrapperId\" class=\"cardon\">\r\n    <div [id]=\"barChartId\"></div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/insa-components/insa-main/insa-main-widgets/mainWindowBarChart.component.html
// module id = 1151
// module chunks = 2